import { createAction } from 'utils/redux'

export const toggleChat = (payload: { chatOpen: boolean, isChatTakeover?: boolean, displayGreeting?: boolean }) => createAction({
  type: 'TOGGLE_CHAT',
  payload
})

export const toggleChatTakeover = payload => createAction({
  type: 'TOGGLE_CHAT_TAKEOVER',
  payload
})

export const toggleChatOpen = () => createAction({
  type: 'OPEN_CHAT'
})

export const toggleChatClosed = () => createAction({
  type: 'CLOSE_CHAT'
})


export const toggleConversationHistory = payload => createAction({
  type: 'TOGGLE_CONVERSATION_HISTORY',
  payload
})

export const toggleInitComplete = payload => createAction({
  type: 'INIT_COMPLETE',
  payload
})

export const toggleMatchedWidgetTargeting = payload => createAction({
  type: 'TOGGLE_WIDGET_TARGETING_MATCHED',
  payload
})

export const setCloseChatRedirectUrl = (closeChatRedirectUrl: string) => createAction({
  type: 'SET_CLOSE_CHAT_REDIRECT_URL',
  payload: closeChatRedirectUrl
})
